import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Col,
  Row,
} from "reactstrap";

import "./ModalAddContact.css";
import { useContext, useRef, useState } from "react";
import InputStandard from "../Inputs/InputStandard";
import { DocumentTypeContext } from "../../context/DocumentContext";
import { getQueryParam } from "../../utils/getQueryOaram";
import { useLocation } from "react-router-dom";
import SignatureCanvas from "react-signature-canvas";
import { AuthContext } from "../../context/AuthContext";
import { UserTypeContext } from "../../context/UserTypeContext";
import { useToast } from "../../context/ToastContext";
import { ContactContext } from "../../context/ContactContext";

interface ModalComponentProps {
  openModal: boolean;
  closeModal: () => void;
}

const ModalAddContact = (props: ModalComponentProps) => {
  const { openModal, closeModal } = props;
  const {
    formValuesContact,
    setFormValuesContact,
    createContact,
    updateContact,
  } = useContext(ContactContext);
  const showToast = useToast();

  const cleanFileds = () => {
    setFormValuesContact([]);
    closeModal();
  };

  const handleBlur = (valueAtt: any, name: string) => {
    setFormValuesContact({
      ...formValuesContact,
      [name]: valueAtt,
    });
  };

  const saveSignature = async () => {
    if (!formValuesContact?.email) {
      showToast("info", "Informe o email");
      return;
    }

    if (!formValuesContact?.phoneNumber) {
      showToast("info", "Informe o telefone");
      return;
    }

    if (!formValuesContact?.name) {
      showToast("info", "Informe o nome");
      return;
    }

    if (formValuesContact?.id) {
      await updateContact();  
    } else {
      await createContact();
    }
    cleanFileds();
  };

  return (
    <div>
      <Modal
        isOpen={openModal}
        toggle={closeModal}
        className="modal-content"
        style={{
          maxWidth: "600px",
          width: "90%",
          borderRadius: "10px",
        }}
      >
        {/* Título */}
        <div
          className="text-center"
          style={{
            color: "#222222",
            fontSize: "22px",
            fontWeight: "bold",
            marginBottom: "15px",
            marginTop: "15px",
          }}
        >
          Adicionar Novo Contato
        </div>

        {/* Corpo do Modal */}
        <ModalBody>
          <form>
            <Row>
              {/* Email */}
              <Col xs="12" className="mb-3">
                <InputStandard
                  type="email"
                  name="email"
                  handleChange={handleBlur}
                  value={formValuesContact?.email}
                  label="E-mail"
                />
              </Col>

              {/* Nome */}
              <Col xs="6" className="mb-3">
                <InputStandard
                  type="text"
                  name="name"
                  handleChange={handleBlur}
                  value={formValuesContact?.name}
                  label="Nome"
                />
              </Col>

              {/* Telefone */}
              <Col xs="6" className="mb-3">
                <InputStandard
                  type="tel"
                  name="phoneNumber"
                  mask="(99) 99999-9999"
                  handleChange={handleBlur}
                  value={formValuesContact?.phoneNumber}
                  label="Telefone"
                />
              </Col>
            </Row>
          </form>
        </ModalBody>

        {/* Botões de Ação */}
        <ModalFooter className="d-flex justify-content-center">
          <Row style={{ width: "100%" }}>
            <Col xs="6">
              <Button className="button-login" onClick={saveSignature} block>
                Salvar
              </Button>
            </Col>
            <Col xs="6">
              <Button color="secondary" onClick={closeModal} block>
                Cancelar
              </Button>
            </Col>
          </Row>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default ModalAddContact;
